import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import {
  ALL_STORES_BLANKSTREET_JOINED,
  SAME_STORES_BLANKSTREET_JOINED,
} from '@/constants'
import { OptimizationsResponseModel } from '@/types/clarityLens'

export const getOptimizations = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<OptimizationsResponseModel> => {
  try {
    if (branchName === 'all') {
      branchName = ALL_STORES_BLANKSTREET_JOINED()
    } else if (branchName === 'same') {
      branchName = SAME_STORES_BLANKSTREET_JOINED
    }

    const response = await axios.get(
      `${BASE_URL}/spend-lens/item/sku-breakdown/optimizations`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          dcn: branchName,
          item_name: itemName,
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
